import wpenginelocal from "../../../../assets/images/docs/wpenginelocal.png";
import * as React from 'react';
export default {
  wpenginelocal,
  React
};